exports.components = {
  "component---src-pages-404-jsx": () => import("./../../../src/pages/404.jsx" /* webpackChunkName: "component---src-pages-404-jsx" */),
  "component---src-pages-sanity-page-meta-info-slug-current-jsx": () => import("./../../../src/pages/{sanityPage.metaInfo__slug__current}.jsx" /* webpackChunkName: "component---src-pages-sanity-page-meta-info-slug-current-jsx" */),
  "component---src-templates-article-jsx": () => import("./../../../src/templates/article.jsx" /* webpackChunkName: "component---src-templates-article-jsx" */)
}

